import React from "react";
import styled from "styled-components";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Col, Row, Text, Img } from "../../comps";
import { Theme } from "../../theme/theme-provider";

import { playlistLogo } from "../../theme/image";
import { playlistDemoGif } from "../../theme/uploaded";
import { faChevronRight, faStream } from "@fortawesome/free-solid-svg-icons";

const Wrapper = styled(Row)`
  width: 100%;
  min-width: 600px;
  margin-top: 30px;
  padding: 20px 20px;
  justify-content: space-between;
  align-items: center;
  /* box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.6); */
`;

const Details = styled(Col)`
  width: 50%;
`;

const Head = styled(Row)`
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.BLUE_5};
`;

const TextContainer = styled(Row)`
  margin-top: 3px;
  padding: 0px 10px;
  align-items: center;
  color: ${({ theme }) => theme.textColor.light};
`;

const ListItem = ({ icon, text }) => {
  return (
    <TextContainer>
      <FontAwesomeIcon
        style={{
          fontSize: "20px",
          color: Theme.textColor.light,
          margin: "5px",
        }}
        icon={icon}
      />
      <Text
        fontFamily={Theme.fontFamily.grenze}
        fontWeight={500}
        color={Theme.textColor.light}
        fontSize="24px"
        textAlign="left"
        marginLeft="8px"
      >
        {text}
      </Text>
    </TextContainer>
  );
};

export default () => {
  return (
    <Wrapper>
      <Details>
        <Col>
          <Head>
            <Text
              marginLeft="10px"
              fontFamily={Theme.fontFamily.grenze}
              fontWeight={600}
              fontSize="32px"
              color={Theme.color.BLUE_5}
              textAlign="left"
            >
              {"Playlists"}
            </Text>
            <Img
              style={{ marginLeft: "8px" }}
              src={playlistLogo}
              width="40px"
              height="40px"
            />
          </Head>
          <ListItem
            text="A place to organise your playlist"
            icon={faChevronRight}
          />
          <ListItem
            text="Add your favourite song or playlist from youtube/spotify"
            icon={faStream}
          />
        </Col>
      </Details>
      <Img height="80%" src={playlistDemoGif} />
    </Wrapper>
  );
};
